var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.data != null && _vm.data.image1 !== null && _vm.data.image1 !== undefined)?_c('section',{staticClass:"home-img-container section text-center"},[_c('div',{staticClass:"swiper-wrapper text-left"},[_c('div',{ref:"one",staticClass:"home-img",style:({
        'background-image': `url(${_vm.getImageUrl(_vm.data.image1)})`,
        'background-size': 'cover',
      })})])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }